import Axios from "axios";
import {
    SET_ASSET_DOCUMENTS_LIST,
    UNSET_ASSET_DOCUMENTS_LIST,
} from "@/store/mutation-types";

import { saveUpdateAssetDocument, getAssetDocumentsList, getAssetDocumentById } from "@/store/api";

const state = {
    getAssetDocumentsList: [],
    getEditingAssetDocument: null,
};

const getters = {
    getAssetDocumentsList(state) {
        return state.getAssetDocumentsList;
    },
};

const mutations = {
    [SET_ASSET_DOCUMENTS_LIST](state, data) {
        state.getAssetDocumentsList = data;
    },
    [UNSET_ASSET_DOCUMENTS_LIST](state) {
        state.getAssetDocumentsList = [];
    },
};

const actions = {
    saveUpdateAssetDocument({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetDocument, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetDocumentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetDocumentsList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_DOCUMENTS_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_DOCUMENTS_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetDocumentById({ commit }, data) {
        const getAssetDocumentsById = `${getAssetDocumentById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetDocumentsById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
